import { render } from "./RIcon.vue?vue&type=template&id=a9faa342"
import script from "./RIcon.vue?vue&type=script&lang=js"
export * from "./RIcon.vue?vue&type=script&lang=js"

import "./RIcon.vue?vue&type=style&index=0&id=a9faa342&lang=css"
script.render = render

export default script